import { render, staticRenderFns } from "./VerticalView.vue?vue&type=template&id=85cc8bb6&scoped=true"
import script from "./VerticalView.vue?vue&type=script&lang=js"
export * from "./VerticalView.vue?vue&type=script&lang=js"
import style0 from "./VerticalView.vue?vue&type=style&index=0&id=85cc8bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cc8bb6",
  null
  
)

export default component.exports